export default "__VITE_ASSET__2UJIhrRS__"